import qs from 'query-string';

import getRouteInfo from './getRouteInfo';
import parameterize from '../parameterize';
import { removeQueryAndHash } from './urlGenerator';

export default (href, route) => {
  let linkObject = {
    href: {},
    as: {},
  };

  // If an object, its intended to only modify the query.  Merge that query and use it as the URL.
  if (typeof href === 'string') {
    // TODO: Implement this using { urlSplitter } from './urlComparer' instead of all of the splits.
    const routeInfo = getRouteInfo(href);

    let queryProperties = {};
    let hash = undefined;
    if (href.indexOf('?') > -1) {
      queryProperties = qs.parse(href.split('?')[1].split('#')[0]);
    }
    if (href.indexOf('#') > -1) {
      hash = href.split('#')[1].split('?')[0];
    }

    linkObject.href = {
      pathname: routeInfo.result.serverPath,
      query: { ...routeInfo.params, ...queryProperties },
    };
    let asPathQuery = { ...routeInfo.params, ...queryProperties };
    delete asPathQuery.slug;
    let hasPathQuery = Object.keys(asPathQuery).length > 0;
    linkObject.as = `${removeQueryAndHash(href)}${
      hasPathQuery ? '?' + qs.stringify(asPathQuery) : ''
    }${hash ? '#' + hash : ''}`;
  } else {
    let combinedQuery = { ...route.query, ...href.query };
    Object.keys(combinedQuery).forEach(
      key => combinedQuery[key] === undefined && delete combinedQuery[key],
    );

    // Create query to use in the URL.  This should not have the slug.
    const asPath = `${removeQueryAndHash(route.asPath)}`;
    const asPathQuery = { ...combinedQuery };
    delete asPathQuery.slug;

    linkObject.href = {
      pathname: route.pathname,
      query: combinedQuery,
      hash: href.hash,
    };
    linkObject.as = {
      pathname: asPath,
      query: asPathQuery,
      hash: href.hash,
    };

    // If this has no `href` (and therefore also `as`) data, but has query data...
    //  ... then we're modifying the query for this page.  Link can use `shallow`
    //  ... and not force a full page refresh.
    if (!href.href && href.query) {
      linkObject.shallow = true;
    }
  }

  return linkObject;
};
